import { type AvatarProps } from '@air/primitive-avatar';
import { formatFullName } from '@air/utilities';

import { getAvatarImageSrc } from '~/utils/getAvatarImageSrc';
import { type RecentlyDeletedResponse } from '../types';

type DeleteBy = RecentlyDeletedResponse['data'][number]['deletedBy'];
type DeleteByAvatarProps = Pick<AvatarProps, 'alt' | 'size' | 'src' | 'text' | 'colorSeed'>;

const AVATAR_SIZE = 24;

export const getDeletedByAvatarProps = (deletedBy: DeleteBy): DeleteByAvatarProps => ({
  alt: `${formatFullName(deletedBy.firstName, deletedBy.lastName)} avatar`,
  size: AVATAR_SIZE,
  src: getAvatarImageSrc(deletedBy.avatar, AVATAR_SIZE),
  text: deletedBy.initials,
  colorSeed: deletedBy.id,
});
